import React from "react";
import { Alert, Box } from "@mui/material";

export default function AbaEmBreve({ titulo, descricao }) {
  return (
    <Box sx={{ p: 2 }}>
      <Alert severity="info">
        <strong>{titulo}</strong> ainda não está disponível nesta apuração.
        {descricao ? ` ${descricao}` : ""}
      </Alert>
    </Box>
  );
}
